import React, { useState, useReducer, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from '@material-ui/core/Tooltip';


export default function DividerLabel(props) {
  const { label, tooltip } = props;
  const [isShown, setIsShown] = useState(false);

  return (
    <div style={{ display: "flex", width: "100%", alignItems: "center", marginTop: 16, marginBottom: 16 }}
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}>
      {label &&
      <div style={{ flex: "0 0 auto", paddingRight: 8, color: "#1982DD" }}>{label}</div>}
      <div style={{ flex: "1 1 auto", height: 1, borderTop: "1px solid #1982DD" }}></div>
      {tooltip && (
        <Tooltip title={tooltip} placement="left">
          <HelpOutlineIcon fontSize="small" color="secondary" style={{ cursor: "pointer", marginLeft: 6 }} />
        </Tooltip>
      )}
    </div>
  );
}
